import { render, staticRenderFns } from "./OpzstatHeadList.vue?vue&type=template&id=5d74d6a1&scoped=true"
import script from "./OpzstatHeadList.vue?vue&type=script&lang=js"
export * from "./OpzstatHeadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d74d6a1",
  null
  
)

export default component.exports